import * as React from 'react';
import { Tooltip as RT } from 'radix-ui';
import { cn } from '@client/lib/utils';

export function TooltipProvider({ children }: { children: React.ReactNode }) {
  return <RT.Provider delayDuration={300}>{children}</RT.Provider>;
}

/** RxTooltip: ink surface, 10px radius, 12px copy; inverts in dark mode. */
export function Tooltip({ content, children, side = 'top' }: { content: React.ReactNode; children: React.ReactElement; side?: 'top' | 'bottom' | 'left' | 'right' }) {
  return (
    <RT.Root>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          side={side}
          sideOffset={6}
          className={cn('z-[900] max-w-xs rounded-[10px] bg-ink px-2.5 py-1.5 text-[12px] font-[500] leading-4 text-white shadow-popover animate-pop dark:bg-white dark:text-ink')}
        >
          {content}
          <RT.Arrow className="fill-ink dark:fill-white" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
